import './style.css';
import React, { useEffect, useState } from 'react'
import { auth, createTimeString, getUserInfo, numberWithComma } from '../../../libs/lib';
import { BASE_ROUTE, SESSION_EXPIRED_CODE } from '../../../config';
import { Button, Collapse, Form, Toast, ToastContainer } from 'react-bootstrap';
import { BsChevronCompactDown, BsChevronCompactUp } from "react-icons/bs";
import Progress from '../../../components/progress';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { http_request } from '../../../libs/connection';
import Decimal from 'decimal.js';
import { cloneDeep } from 'lodash';

const ASC = 0;
const DESC = 1;
const INIT = 0;
const SEARCH = 1;
const MANUALLY = 2;
var param_status;

const InvoiceList = () => {
  const user_info = getUserInfo();
  const [search_params, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [list, setList] = useState([]);
  const [other_list, setOtherList] = useState([]);
  const [selected_year, selectYear] = useState((new Date()).getFullYear());
  const [selected_month, selectMonth] = useState(createTimeString('m'));
  const [search, setSearch] = useState('');
  const [filter_show, showFilter] = useState(false);
  const [is_loading, setLoadingStatus] = useState(false);
  const [success_message, setSuccessMessage] = useState('');
  const [error_message, setErrorMessage] = useState('');
  const [success_toast_show, showSuccessToast] = useState(false);
  const [error_toast_show, showErrorToast] = useState(false);
  const [sort_by, setSortBy] = useState({
    column: null,
    ordering: ASC
  });

  useEffect(()=>{
    param_status = [...(search_params.values())].length ? SEARCH : INIT;
  }, [pathname]);

  useEffect(()=>{
    sortItem();
  }, [sort_by]);
  
  function loadData(){
    if(is_loading) return;
    
    let params = {
      date: `${selected_year}-${selected_month}`,
      cu_no: user_info.cu_no,
    };

    setLoadingStatus(true);
    setSortBy({
      column: null,
      ordering: ASC
    });
    http_request('/invoice/get', 'POST', params).then(res=>{
      setLoadingStatus(false);
      if(res.success){
        setList((res.data.invoices || []).filter(row=>row.flag !== 'D').map(row=>{
          row.tax_name = getTaxName(row.ch_taxid);
          row.sub_totamt_r = calcSubtotal(row.ch_taxid, row.ch_price, row.ch_aqty2, row.ie_rtax);//原幣小計(未) = 入退數量(ch_aqty2) * 單價(ch_price)
          row.sub_totamt_rr = calcSubtotal(row.ch_taxid, Decimal.mul(row.ch_price, row.od_rate), row.ch_aqty2, row.ie_rtax);//國幣小計(未) = 入退數量(ch_aqty2) * 單價(ch_price) * 匯率(od_rate)
          row.sub_totamt = calcSubtotalWithTax(row.ch_taxid, row.ch_price, row.ch_aqty2, row.sub_totamt_r, row.ie_rtax);//原幣小計
          row.sub_totamt1 = calcSubtotalWithTax(row.ch_taxid, row.ch_price, row.ch_aqty2, row.sub_totamt_rr, row.ie_rtax);//國幣小計
          return row;
        }).sort(function(a, b){
          if(a?.fd_no === undefined || b?.fd_no === undefined) return 0;
          if(a.fd_no > b.fd_no) return 1;
          if(a.fd_no < b.fd_no) return -1;
          return 0;
        }));
        setOtherList((res.data.invoice_others || []).filter(row=>row.flag !== 'D'));
      }else if(res.message === SESSION_EXPIRED_CODE){
        navigate(`${BASE_ROUTE}/logout`);
      }
    });
  }
  function query(){
    param_status = MANUALLY;
    setSearchParams({
      year: selected_year,
      cu_no: user_info.cu_no,
      search
    });
    loadData();
  }
  
  function sortItem(){
    let { column, ordering } = sort_by;
    if(column === null) return;
    let sorted_list = [...list].sort((a, b)=>{
      let av = a[column] || '';
      let bv = b[column] || '';
      let is_greater = av > bv;
      let is_smaller = av < bv;
      let is_equal = av === bv;
      switch(ordering){
        case ASC:
          if(is_greater) return 1;
          if(is_smaller) return -1;
          if(is_equal) return 0;
          break;
        case DESC:
          if(is_greater) return -1;
          if(is_smaller) return 1;
          if(is_equal) return 0;
          break;
        default:
          if(is_greater) return 1;
          if(is_smaller) return -1;
          if(is_equal) return 0;
          break;
      }
      return 0;
    });
    setList(sorted_list);
  }
  function sortItemBy(selected_column){
    let { column, ordering } = sort_by;
    if(selected_column === column){
      ordering = ordering === ASC ? DESC : ASC;
    }else{
      column = selected_column;
      ordering = ASC;
    }
    setSortBy({
      column,
      ordering
    })
  }
  function checkInvoice(){
    let res = window.confirm("再次确认");
    if(!res) return;

    let params = {
      cu_no: user_info.cu_no,
      date: `${selected_year}-${selected_month}`
    };
    setLoadingStatus(true);
    http_request('/invoice/confirm', 'POST', params).then(res=>{
      setLoadingStatus(false);
      if(res.success){
        loadData();
        showSuccessToast(true);
        setSuccessMessage('请款单确认成功');
      }else if(res.message === SESSION_EXPIRED_CODE){
        navigate(`${BASE_ROUTE}/logout`);
      }else{
        showErrorToast(true);
        setErrorMessage(res.message);
      }
    });
  }
  function isCheckButtonDisabled(){
    return ((list || []).filter(row=>{
      return (row.result || '').substr(0, 1) !== '0';
    })).length === 0;
  }
  function getTaxName(tax_id){
    switch(tax_id + ''){
      case '1':
        return '零税';
      case '2':
        return '免税';
      case '3':
        return '外加';
      case '4':
        return '内含';
      case '5':
        return '不开';
      default:
        return '--';
    }
  }
  function calcSubtotal(ch_taxid, ch_price, ch_aqty2, ie_rtax){//計算未稅金額
    switch(ch_taxid + ''){
      case '4'://内含
        //(單價{ch_price}x入退數量{ch_aqty2}) / (1 + 稅率{ie_rtax})
        return Decimal.mul(ch_price, ch_aqty2).div(Decimal.add(1, ie_rtax)).toNumber();
      default://零税, 免税, 不开, 外加
        //(單價{ch_price}x入退數量{ch_aqty2})
        return Decimal.mul(ch_price, ch_aqty2).toNumber();
    }
  }
  function calcSubtotalWithTax(ch_taxid, ch_price, ch_aqty2,  excluding_tax, ie_rtax){//計算稅後金額
    switch(ch_taxid + ''){
      case '3'://外加
        //稅額=(單價{ch_price}x入退數量{ch_aqty2}) * 稅率{ie_rtax}
        return Decimal.mul(ch_price, ch_aqty2).mul(Decimal.add(1, ie_rtax));
      case '4'://内含
        //稅額=(單價{ch_price}x入退數量{ch_aqty2}) - 未稅金額
        return Decimal.mul(ch_price, ch_aqty2);
      default://零税, 免税, 不开
        //稅額 = 0
        return excluding_tax;
    }
  }
  return (
    <div id="page-invoice-list" className={`page`}>
      <Progress show={is_loading} />
      <ToastContainer 
          position='middle-bottom'
          style={{ zIndex: 1056 }}
          >
          <Toast 
              show={success_toast_show} 
              onClose={()=>{ showSuccessToast(false); }}
              delay={2000}
              autohide
              bg="success"
              className='text-white'
          >
              <Toast.Header>
                  <strong className="me-auto">确认完成</strong>
              </Toast.Header>
              <Toast.Body>{success_message}</Toast.Body>
          </Toast>
          <Toast 
              show={error_toast_show} 
              onClose={()=>{ showErrorToast(false); }}
              delay={3000}
              autohide
              bg="danger"
              className='text-white'
          >
              <Toast.Header>
                  <strong className="me-auto">确认失败</strong>
              </Toast.Header>
              <Toast.Body>{error_message}</Toast.Body>
          </Toast>
      </ToastContainer>
      <div className={`datepicker_pannel bg-white p-3`}>
        <div className='d-lg-none d-flex align-items-center'>
          <span className='fs-6'>请款单查询</span>
          <span className='d-flex flex-grow-1 align-items-center justify-content-end' onClick={()=>{ showFilter(!filter_show); }}>
            {
              filter_show ? <BsChevronCompactUp /> : <BsChevronCompactDown />
            }
          </span>
        </div>
        <Collapse in={filter_show}>
          <div>
            <div className='d-block d-lg-none'>
              <SearchBar
                  selected_year={selected_year}
                  selectYear={selectYear}
                  selected_month={selected_month}
                  selectMonth={selectMonth}
                  query={query}
                  check_button_disabled={isCheckButtonDisabled()}
                  checkInvoice={checkInvoice}
              />
            </div>
          </div>
        </Collapse>
        <div className='d-none d-lg-block'>
          <SearchBar
              selected_year={selected_year}
              selectYear={selectYear}
              selected_month={selected_month}
              selectMonth={selectMonth}
              query={query}
              check_button_disabled={isCheckButtonDisabled()}
              checkInvoice={checkInvoice}
          />
        </div>
      </div>
      <div className={`content p-2 d-flex flex-column`}>
        {
          (list || []).length === 0 ? <div className='flex-grow-1 d-flex align-items-center justify-content-center'>
            <span className='text-secondary'>无资料</span>
          </div> : <>
            {
              auth('company.invoice.confirm') && <div className='d-flex d-sm-none py-3 align-items-center justify-content-center'>
                <Button
                  size="sm"
                  variant='success'
                  onClick={()=>{ checkInvoice(); }}
                  disabled={isCheckButtonDisabled()}
                >厂商确认</Button>
              </div>
            }
              <div className='bg-light flex-grow-1 overflow-x-auto'>
                <h1 className='fs-5 text-center mt-3'>凹凸精密机械有限公司</h1>
                <h3 className='fs-6 text-center'>货款请款单料件明细表_{selected_year}-{selected_month}</h3>
                <table className={`border border-dark m-auto dtable bg-light`}>
                  <thead>
                      <tr>
                          <th className={`sortable ${sort_by.column === 'mt_list' ? 'active' : ''}`} onClick={()=>{ sortItemBy('mt_list'); }}>入库单号</th>
                          <th className={`sortable ${sort_by.column === 'ch_no' ? 'active' : ''}`} onClick={()=>{ sortItemBy('ch_no'); }}>採购单号</th>
                          <th className={`sortable ${sort_by.column === 'fd_no' ? 'active' : ''}`} onClick={()=>{ sortItemBy('fd_no'); }}>送货单号</th>
                          <th className={`sortable ${sort_by.column === 'el_no' ? 'active' : ''}`} onClick={()=>{ sortItemBy('el_no'); }}>料品编号</th>
                          <th className={`sortable ${sort_by.column === 'el_name1' ? 'active' : ''}`} onClick={()=>{ sortItemBy('el_name1'); }}>品名</th>
                          <th className={`sortable ${sort_by.column === 'ch_qty2' ? 'active' : ''}`} onClick={()=>{ sortItemBy('ch_qty2'); }}>收货数量</th>
                          <th className={`sortable ${sort_by.column === 'rej_dealqty2' ? 'active' : ''}`} onClick={()=>{ sortItemBy('rej_dealqty2'); }}>拒收数量</th>
                          <th className={`sortable ${sort_by.column === 'ch_aqty2' ? 'active' : ''}`} onClick={()=>{ sortItemBy('ch_aqty2'); }}>入退数量</th>
                          <th className={`sortable ${sort_by.column === 'ch_price' ? 'active' : ''}`} onClick={()=>{ sortItemBy('ch_price'); }}>单价</th>
                          <th className={`sortable ${sort_by.column === 'tax_name' ? 'active' : ''}`} onClick={()=>{ sortItemBy('tax_name'); }}>稅別</th>
                          <th className={`sortable ${sort_by.column === 'ie_rtax' ? 'active' : ''}`} onClick={()=>{ sortItemBy('ie_rtax'); }}>稅率</th>
                          <th className={`sortable ${sort_by.column === 'sub_totamt_r' ? 'active' : ''}`} onClick={()=>{ sortItemBy('sub_totamt_r'); }}>原币小计(未)</th>
                          <th className={`sortable ${sort_by.column === 'sub_totamt_rr' ? 'active' : ''}`} onClick={()=>{ sortItemBy('sub_totamt_rr'); }}>国币小计(未)</th>
                          <th className={`sortable ${sort_by.column === 'sub_totamt' ? 'active' : ''}`} onClick={()=>{ sortItemBy('sub_totamt'); }}>原币小计</th>
                          <th className={`sortable ${sort_by.column === 'sub_totamt1' ? 'active' : ''}`} onClick={()=>{ sortItemBy('sub_totamt1'); }}>国币小计</th>
                      </tr>
                  </thead>
                  <tbody>
                    {
                      (list || []).map((row, i)=><tr key={i}>
                        <td>{row.mt_list}</td>
                        <td>{row.ch_no}</td>
                        <td>{row.fd_no}</td>
                        <td>{row.el_no}</td>
                        <td>{row.el_name1}</td>
                        <td>{row.ch_qty2}</td>
                        <td>{row.rej_dealqty2}</td>
                        <td>{row.ch_aqty2}</td>
                        <td>{numberWithComma(Decimal(row.ch_price))}</td>
                        <td>{row.tax_name}</td>
                        <td>{row.ie_rtax}</td>
                        <td>{numberWithComma(Decimal(row.sub_totamt_r).toFixed(2))}</td>
                        <td>{numberWithComma(Decimal(row.sub_totamt_rr).toFixed(2))}</td>
                        <td>{numberWithComma(Decimal(row.sub_totamt).toFixed(2))}</td>
                        <td>{numberWithComma(Decimal(row.sub_totamt1).toFixed(2))}</td>
                      </tr>)
                    }
                    <tr>
                      <td colSpan={9}></td>
                      <td colSpan={2}>合计总金额</td>
                      <td>{numberWithComma(Decimal.sum(...(list.map(row=>row.sub_totamt_r))).toFixed(2))}</td>
                      <td>{numberWithComma(Decimal.sum(...(list.map(row=>row.sub_totamt_rr))).toFixed(2))}</td>
                      <td>{numberWithComma(Decimal.sum(...(list.map(row=>row.sub_totamt))).toFixed(2))}</td>
                      <td>{numberWithComma(Decimal.sum(...(list.map(row=>row.sub_totamt1))).toFixed(2))}</td>
                    </tr>
                    <tr>
                      <td colSpan={15}></td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr>
                        <th>序号</th>
                        <th colSpan={3}>应付款事项</th>
                        <th>金额</th>
                        <th colSpan={10}>备註</th>
                    </tr>
                  </tbody>
                  <tbody>
                    {
                      (other_list || []).map((row, i)=><tr key={i}>
                        <td>{row.other_seq}</td>
                        <td colSpan={3}>{row.name}</td>
                        <td>{numberWithComma(Decimal(row.amt || 0))}</td>
                        <td colSpan={10}>{row.remark}</td>
                      </tr>)
                    }
                  </tbody>
              </table>
            </div>
          </>
        }
      </div>
      
      
    </div>
  )
}

function SearchBar({
  selected_year,
  selectYear,
  selected_month,
  selectMonth,
  query,
  check_button_disabled,
  checkInvoice
}){
  return <div className='d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center container' style={{ height: 'auto', overflowY: 'visible' }}>
    <div className='d-flex flex-column flex-sm-row align-items-sm-center mb-lg-0 mb-3 mt-3 mt-sm-0'>
      <Form.Group className='mx-sm-3 d-flex align-items-center mt-3 mt-sm-0'>
        <Form.Label className='pe-2 m-0 d-block d-sm-none text-nowrap'>年份　</Form.Label>
        <Form.Label className='pe-2 m-0 d-none d-sm-block text-nowrap'>年份</Form.Label>
        <Form.Select
          onChange={e=>{ selectYear(e.currentTarget.value); }}
          value={selected_year}
          size="sm"
        >
          <option value="">选择年份</option>
          {
            (new Array((new Date).getFullYear() - 1999)).fill(null).map((e, i)=>{
              let now = new Date();
              let opt = now.getFullYear() - i;
              return <option key={i} value={opt}>{opt}</option>
            })
          }
        </Form.Select>
      </Form.Group>
      <Form.Group className='mx-sm-3 d-flex align-items-center mt-3 mt-sm-0'>
        <Form.Label className='pe-2 m-0 d-block d-sm-none text-nowrap'>月份　</Form.Label>
        <Form.Label className='pe-2 m-0 d-none d-sm-block text-nowrap'>月份</Form.Label>
        <Form.Select
          onChange={e=>{ selectMonth(e.currentTarget.value); }}
          value={selected_month}
          size="sm"
        >
          <option value="">选择月份</option>
          {
            (new Array(12)).fill(null).map((e, i)=>{
              let opt = `0${(i + 1)}`.substr(-2);
              return <option key={i} value={opt}>{opt}</option>
            })
          }
        </Form.Select>
      </Form.Group>
    </div>
    <div className='d-flex align-items-center justify-content-center pt-2 pt-sm-0'>
      <Button variant='primary' size='sm' className='px-sm-3 px-5 text-nowrap' disabled={!selected_month || !selected_year} onClick={()=>{ query(); }}>查询</Button>
    </div>
    {
      auth('company.invoice.confirm') && <div className='flex-grow-1 d-none d-sm-flex align-items-center justify-content-end'>
        <Button
          size="sm"
          variant='success'
          onClick={()=>{ checkInvoice(); }}
          disabled={check_button_disabled}
        >厂商确认</Button>
      </div>
    }
  </div>;
}

export default InvoiceList